import { Component } from '@angular/core';
// import * as data from '../../../../git-version.json'

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div class="col-md-5 moka-logo"> 
    </div>
    <div class="col-md-7 moka-version"> 
      <span class="created-by"> 
      </span>
    </div>
  `,
})
export class FooterComponent {
  // public git = data;
}
